import TableViewRowWithBars from './tableViewRowWithBars'
export default TableViewRowWithBars
